import { useState } from 'react';

export function useToken() {
  const getToken = () => {
    if (localStorage.getItem('token') != null) {
      const tokenString = localStorage.getItem('token');
      const userToken = JSON.parse(tokenString);
      return userToken
    }
    return ""
  };

  const saveToken = userToken => {
    localStorage.setItem('token', JSON.stringify(userToken));
  };

  return [
    getToken,
    saveToken
  ]
}
